import { SuggestionData } from 'ckeditor5-premium-features'
import { TrackedChange } from 'models/changes'
import React, { memo, useMemo } from 'react'
import { getTrackChangeById } from '../../utils/TrackChangesAndSuggestionsUtils'
import { TrackChangeCard as Card } from './card/Card'

export interface SuggestionCardWrapperProps {
    suggestion: SuggestionData
    trackChangesData: Record<string, TrackedChange>
    isNotDefaultSuggestionCardFilter?: boolean
    index: number
    suggestionCardFilter?: string
}

/**
 * SuggestionCardWrapper component renders a card for track changes based on the suggestion and its status.
 * It uses memoization to optimize performance and avoid unnecessary re-renders.
 *
 * The component determines the appropriate track change status based on filter criteria
 * and renders the corresponding card if valid track change data exists.
 *
 * @param props - The properties for the SuggestionCardWrapper component
 * @returns The rendered suggestion card or null if no valid track change data
 */
export const SuggestionCardWrapper = memo<SuggestionCardWrapperProps>(
    ({
        suggestion,
        trackChangesData,
        isNotDefaultSuggestionCardFilter = false,
        suggestionCardFilter,
    }) => {
        const trackChange = useMemo(
            () =>
                getTrackChangeById(
                    suggestion,
                    trackChangesData,
                    suggestionCardFilter
                ),
            [suggestion, trackChangesData, suggestionCardFilter]
        )

        if (!trackChange) {
            return null
        }

        return (
            <Card
                cardSuggestion={suggestion}
                trackChanges={trackChange}
                isNotDefaultSuggestionCardFilter={
                    isNotDefaultSuggestionCardFilter
                }
            />
        )
    }
)
